import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05c6875e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data ws_mr5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "请选择要分配的设备(可多选)：", -1))
const _hoisted_3 = { class: "device-list" }
const _hoisted_4 = { class: "icon-box" }
const _hoisted_5 = { class: "right-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "请选择要分配的组织(单选)：", -1))
const _hoisted_7 = { class: "tree-list" }
const _hoisted_8 = { class: "custom-tree-node" }
const _hoisted_9 = { class: "ws_drawer_footer" }

import { ref, watch, computed } from 'vue'
import type { FormInstance } from 'element-plus'
import { ElMessage } from 'element-plus'
import { CODE_ENUM } from '@/common'
import { queryOrgTreeList, sendDeviceToOrg } from '@/api'
import { isEmpty, cloneDeep } from 'lodash'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'device-distribution',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: $emit }) {

const props = __props;

const t = i18n.global.t




watch(
  () => props.visible,
  () => {
    if (props.visible) {
      queryOrg()
      const data = cloneDeep(props.data)
      deviceList.value = data.map((item: any) => {
        const { deviceName, deviceId, ...p } = item
        return {
          ...p,
          deviceName,
          deviceId,
          label: deviceName,
          id: deviceId,
          isDeviceLeaf: true,
        }
      })
      checkList.value = data.map((_: any) => _.deviceId)
    }
  }
)

const deviceList: any = ref([])

const deepFormat = (
  list: any,
  level = 0,
  topOrgName = '-',
  parentOrgId?: any
) => {
  if (isEmpty(list)) {
    return
  }
  return list.map((item: any) => {
    const { children, id, name, ...p } = item
    return {
      ...p,
      name,
      value: id,
      id,
      label: name,
      children: deepFormat(children, level + 1, name, id),
      level: level + 1,
      topOrgName,
      parentOrgId,
      class: 'node_' + id,
    }
  })
}

const insertDeviceTreeData = (list: any, pId: any, checkDeviceList: any) => {
  if (isEmpty(list)) {
    return
  }
  return list.map((item: any) => {
    const { children, id, ...p } = item
    if (pId === id) {
      if (isEmpty(children)) {
        return {
          ...p,
          id,
          children: checkDeviceList,
        }
      } else {
        return {
          ...p,
          id,
          children: checkDeviceList.concat(children),
        }
      }
    }
    return {
      ...p,
      id,
      children: insertDeviceTreeData(children, pId, checkDeviceList),
    }
  })
}

const removeDeviceTreeData = (list: any, removeDeviceId: any) => {
  if (isEmpty(list)) {
    return
  }
  return list
    .map((item: any) => {
      const { children, deviceId, isDeviceLeaf, ...p } = item
      if (deviceId === removeDeviceId && isDeviceLeaf) {
        return undefined
      }
      return {
        ...p,
        deviceId,
        isDeviceLeaf,
        children: removeDeviceTreeData(children, removeDeviceId),
      }
    })
    .filter(Boolean)
}

// 已经转到右边的设备
const rightDeviceList: any = ref([])
const toRight = () => {
  const checkDeviceList = deviceList.value.filter((_: any) => {
    return checkList.value.includes(_.deviceId)
  })
  moOrgList.value = insertDeviceTreeData(
    orgList.value,
    currentKey.value,
    checkDeviceList
  )

  rightDeviceList.value = cloneDeep(checkList.value)
}

const currentKey = ref()

// 原始组织
const orgList: any = ref([])
// 操作后的组织
const moOrgList: any = ref([])

const queryOrg = async () => {
  const res: any = await queryOrgTreeList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    const result = deepFormat([res.data])

    orgList.value = result
    moOrgList.value = result

    currentKey.value = res.data?.id
  }
}

const cancel = () => {
  $emit('update:visible', false)
  deviceList.value = []
  rightDeviceList.value = []
}

const checkList: any = ref([])

const treeKey = ref(Math.random())
const handleNodeClick = (value: any) => {
  if (value.isDeviceLeaf) {
    treeKey.value = Math.random()
    return
  }
  currentKey.value = value.id
}

const removeLeaf = (id: any) => {
  console.log(id, '=')
  moOrgList.value = removeDeviceTreeData(moOrgList.value, id)
  rightDeviceList.value = rightDeviceList.value.filter((_: any) => _ !== id)
}

const submit = async () => {
  const res: any = await sendDeviceToOrg({
    orgId: currentKey.value,
    deviceIds: rightDeviceList.value,
  })
  if (res?.code === 0) {
    ElMessage({
      message: res.msg,
      type: 'success',
    })
    $emit('success')
    cancel()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    title: "设备分配",
    size: "777px",
    "before-close": cancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_9, [
        _createVNode(_component_el_button, {
          onClick: submit,
          disabled: !rightDeviceList.value.length,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('CONFIG.btnYes')), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          onClick: cancel,
          plain: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('CONFIG.btnCancel')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_checkbox_group, {
              modelValue: checkList.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkList).value = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deviceList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_checkbox, {
                    key: item.deviceId,
                    class: "row-check",
                    label: item.deviceId
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.deviceName), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            onClick: toRight,
            class: "icon-t"
          }, [
            _createVNode(_component_el_icon, { color: "#fff" }, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowRight)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(), _createBlock(_component_el_tree, {
              style: {"max-width":"280px"},
              data: moOrgList.value,
              "node-key": "id",
              "default-expand-all": "",
              "expand-on-click-node": false,
              onNodeClick: handleNodeClick,
              "highlight-current": true,
              "current-node-key": currentKey.value,
              key: treeKey.value
            }, {
              default: _withCtx(({ node, data }) => [
                _createElementVNode("span", _hoisted_8, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["label", { 'height-light': data.isDeviceLeaf }])
                  }, _toDisplayString(node.label), 3),
                  (data.isDeviceLeaf)
                    ? (_openBlock(), _createBlock(_component_el_icon, {
                        key: 0,
                        onClick: _withModifiers(($event: any) => (removeLeaf(data.deviceId)), ["stop"]),
                        color: "#1D58D4",
                        class: "del-icon"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Delete)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["data", "current-node-key"]))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})